// Lib
import React from 'react';

// Components
import PublishPreviewToast from './preview/PublishPreviewToast';
import ClearSearchToast from '../components/search/ClearSearchToast';
import FileTransferToast from '../element/attachments/FileTransferToast';
import BoardPermissionToast from './permissions/toast/BoardPermissionToast';
import ZoomToast from '../canvas/zoom/toast/ZoomToast';

const WorkspaceToasts: React.FC = () => {
    return (
        <>
            <BoardPermissionToast />
            <PublishPreviewToast />
            <FileTransferToast />
            <ClearSearchToast />
            <ZoomToast />
        </>
    );
};

export default WorkspaceToasts;
